import React from "react";
import { Link } from "react-router-dom";
import { ChevronLeft, ShieldCheck } from "lucide-react";
import PlanShowcase from "@/components/PlanShowcase";
import { BRAND } from "@/lib/api";

/** Standalone `/pricing` deep-link. Same showcase used in the login tab. */
export default function Pricing() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-secondary/40 to-white">
      <header className="border-b border-border bg-white">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-4">
          <Link to="/" className="font-heading text-xl font-semibold text-brand">
            Care&apos;O <span className="text-xs text-ink-muted">by Steward</span>
          </Link>
          <Link to="/login" className="inline-flex items-center gap-1 text-sm text-brand hover:text-brand-700">
            <ChevronLeft size={14} />Back to login
          </Link>
        </div>
      </header>

      <main className="mx-auto max-w-6xl px-6 py-10">
        <div className="mb-8 text-center">
          <div className="mb-2 inline-flex items-center gap-1 rounded-full bg-brand/10 px-3 py-1 text-[10px] font-semibold uppercase tracking-wider text-brand">
            <ShieldCheck size={11} />{BRAND.name} plans
          </div>
          <h1 className="font-heading text-3xl font-semibold">Choose the plan that fits your clinic</h1>
          <p className="mt-2 text-sm text-ink-muted">Start free · Upgrade anytime · GST invoice included · Cancel anytime.</p>
        </div>
        <PlanShowcase />
      </main>
    </div>
  );
}
